import Image from 'next/image'
import Link from 'next/link'
import type { FC, HTMLAttributes } from 'react'
import { siteConfig } from '@/config/site'
import logoBlackPng from '@/public/logos/logo_black.png'
import logoPrimaryPng from '@/public/logos/logo_primary.png'
import { cn } from '@/utils/cn'

interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'primary'
  noLink?: boolean
  asH1?: boolean
}

export const Logo: FC<LogoProps> = ({
  variant = 'default',
  noLink = false,
  asH1 = false,
  className,
  ...props
}) => {
  const Text = asH1 ? 'h1' : 'span'

  const content = (
    <div className={cn('flex select-none items-center gap-2', className)} {...props}>
      <Image
        src={variant === 'default' ? logoBlackPng : logoPrimaryPng}
        height={36}
        className={cn('block shrink-0 rounded-lg', variant === 'default' && 'dark:invert')}
        alt={`${siteConfig.name} Logo`}
        priority
      />

      <Text
        className={cn(
          'shrink-0 whitespace-nowrap font-display text-foreground text-lg leading-none ',
        )}
      >
        <span className="mr-0.5 font-black">Backlink</span>
        <span className="font-medium">GPT</span>
      </Text>
    </div>
  )

  return noLink ? content : <Link href="/">{content}</Link>
}
